import styled from 'styled-components';

import {Typography} from '@material-ui/core';

export const Title = styled(Typography).attrs({component: 'div', variant: 'h5'})`
  margin-bottom: 10px;
`;
